export const recipes = [
    {
        "id": "1",
        "name": "Creamy Potato Soup",
        "category": "soups",
        "description": "A hearty soup with potatoes, carrots, and a creamy finish.",
        "prepTime": "15 mins",
        "cookTime": "25 mins",
        "servings": 6,
        "image": "https://cdn.midjourney.com/4d4a7c67-2bce-4808-834c-cefc34c8dcd7/0_2.png",
        "ingredients": [
          "6 cups potatoes, diced",
          "2 cups carrots, shredded",
          "5 cups water",
          "5 tsp instant chicken bouillon (or 5 cubes)",
          "2 ½ tsp onion salt (or similar spices)",
          "½ cup butter, melted",
          "2 tbsp flour",
          "1–2 cups milk"
        ],
        "instructions": [
          "Combine potatoes, carrots, water, bouillon, and onion salt in a pot. Cook until potatoes are tender.",
          "Mix melted butter and flour until smooth, then add to the soup.",
          "Cook until thick and bubbly.",
          "Stir in milk (1–2 cups) without boiling. Heat and serve."
        ]
    },
      
    {
        "id": "2",
        "name": "Mashed Potatoes",
        "category": "sides",
        "description": "Creamy and buttery mashed potatoes, perfect as a side dish.",
        "prepTime": "10 mins",
        "cookTime": "20 mins",
        "servings": 6,
        "image": "https://cdn.midjourney.com/94a4de7e-8438-4da3-8886-25088d7e9ce6/0_3.png",
        "ingredients": [
          "6 large potatoes",
          "1/2 cup butter",
          "1/4 cup milk",
          "2 tbsp salt"
        ],
        "instructions": [
          "Peel and dice the potatoes, then boil them in water with 2 tbsp salt until soft.",
          "Drain the potatoes and mash them in a large bowl.",
          "Mix in the butter and milk, adjusting the amount of milk to reach your desired consistency.",
          "Taste and adjust butter or seasoning as needed. Serve warm."
        ]
    },      
    {
        "id": "3",
        "name": "Classic Cornbread",
        "category": "sides",
        "description": "A moist and slightly sweet cornbread, perfect as a side or a snack.",
        "prepTime": "15 mins",
        "cookTime": "35 mins",
        "servings": 8,
        "image": "https://cdn.midjourney.com/009f8b4f-7864-4502-8d67-94955c8a8c19/0_2.png",
        "ingredients": [
          "1/2 cup butter",
          "2/3 cup white sugar",
          "2 large eggs",
          "1 cup buttermilk",
          "1/2 teaspoon baking soda",
          "1 cup cornmeal",
          "1 cup all-purpose flour",
          "1/4 teaspoon salt"
        ],
        "instructions": [
          "Preheat oven to 375°F (175°C). Grease an 8-inch square pan.",
          "Melt the butter in a large skillet, then remove from heat and stir in the sugar. Quickly add the eggs and beat until well blended.",
          "Combine the buttermilk with baking soda, then stir it into the butter mixture.",
          "Add the cornmeal, flour, and salt, stirring until blended (a few lumps are okay). Pour the batter into the prepared pan.",
          "Bake in the preheated oven for 30–40 minutes, or until a toothpick inserted in the center comes out clean."
        ]
    },
    {
        "id": "4",
        "name": "Nutella Strawberry Cake",
        "category": "desserts",
        "description": "A decadent chocolate cake layered with Nutella, whipped cream, and fresh strawberries.",
        "prepTime": "30 mins",
        "cookTime": "20 mins",
        "servings": 12,
        "image": "https://cdn.midjourney.com/0251c0c0-9afc-4043-8809-9b30336fbe89/0_0.png",
        "ingredients": [
          "2 sticks butter",
          "4 tablespoons (heaping) cocoa powder",
          "1 cup boiling water",
          "2 cups plus 1.5 tablespoons all-purpose flour",
          "2 cups minus 2 tablespoons sugar",
          "1/4 teaspoon salt",
          "1/2 cup plus 3 tablespoons buttermilk",
          "2 whole eggs",
          "1 teaspoon baking soda",
          "1 teaspoon vanilla",
          "1 1/2 cups Nutella",
          "2 pints strawberries, hulled and sliced",
          "1/4 cup sugar (for strawberries)",
          "1 teaspoon vanilla (for strawberries)",
          "2 cups heavy cream",
          "1/2 cup powdered sugar"
        ],
        "instructions": [
          "Preheat the oven to 350°F (175°C). Line two round baking pans with parchment paper and spray the parchment with baking spray.",
          "In a medium saucepan, melt the butter. Add the cocoa and stir until smooth. Pour in the boiling water, let the mixture bubble up for 20 seconds, then turn it off and set aside.",
          "In a measuring pitcher or bowl, mix together the buttermilk, baking soda, eggs, and vanilla. Set aside.",
          "In a large mixing bowl, mix together the sugar, flour, and salt. Stir in the hot chocolate mixture, stirring gently until it's halfway combined and less hot. Pour in the buttermilk mixture and continue stirring gently until the batter is fully combined.",
          "Divide the batter evenly between the prepared pans and bake for 17–20 minutes, or until just set. Remove the cakes from the pans and allow them to cool completely.",
          "Prepare the strawberries by stirring them with the sugar and vanilla. Let them macerate for 15 minutes, then drain off the excess juice.",
          "Whip the cream with the powdered sugar until soft peaks form.",
          "To assemble the cake, place one layer upside down on a serving platter. Spread half the Nutella evenly over the surface. Spread on half the whipped cream and top with half the strawberries. Place the second cake layer upside down on top and repeat with the remaining Nutella, whipped cream, and strawberries.",
          "Keep the assembled cake chilled until serving. Cut with a serrated knife.",
          "Note: Do not assemble the cake more than an hour before serving."
        ]
      },
      {
        "id": "5",
        "name": "Pumpkin Chocolate Chip Cookies",
        "category": "desserts",
        "description": "Soft and flavorful pumpkin cookies with a hint of spice and melty chocolate chips.",
        "prepTime": "15 mins",
        "cookTime": "10 mins",
        "servings": 48,
        "image": "/images/pumpkin_cookies.jpg",
        "ingredients": [
          "5 cups all-purpose flour",
          "2 teaspoons baking powder",
          "2 teaspoons baking soda",
          "2 teaspoons cinnamon",
          "1 teaspoon nutmeg",
          "1/2 teaspoon salt",
          "3 cups granulated sugar",
          "1 cup vegetable oil",
          "2 eggs",
          "1 teaspoon vanilla extract",
          "1 (29-ounce) can pumpkin puree (not pumpkin pie filling)",
          "12 ounces chocolate chips"
        ],
        "instructions": [
          "Preheat oven to 350°F. Grease a cookie sheet or line with parchment paper.",
          "In a large bowl, sift together the flour, baking powder, baking soda, cinnamon, nutmeg, and salt. Set aside.",
          "In another bowl, beat together the sugar, vegetable oil, eggs, and vanilla until well combined.",
          "Add the pumpkin puree and the dry ingredients alternately to the mixture, mixing until just combined.",
          "Fold in the chocolate chips.",
          "Drop by teaspoonfuls onto the prepared cookie sheet.",
          "Bake for 10 minutes or until the edges are set and the cookies are lightly golden.",
          "Cool on a wire rack before serving."
        ]
      },
      {
        "id": "6",
        "name": "Vanilla Ice Cream",
        "category": "desserts",
        "description": "Rich and creamy homemade vanilla ice cream with a classic flavor.",
        "prepTime": "15 mins",
        "cookTime": "27 mins",
        "servings": 12,
        "image": "https://cdn.midjourney.com/8590611f-cffd-4eb5-aec7-17f3b7ecbae0/0_1.png",
        "ingredients": [
          "5 eggs",
          "2 1/2 cups sugar",
          "1/2 cup milk",
          "Pinch of salt (1/8 – 1/4 tsp)",
          "1 cup vanilla extract (not quite full, plus an extra capful for the base)",
          "3 1/2 cups cream",
          "Enough milk to fill up to 2/3 of the container (approximately 1–1.5 cups)",
          "1.5 cups rock salt",
          "Ice"
        ],
        "instructions": [
          "Prepare the Ice Cream Base:",
          "In a KitchenAid mixer, set the speed to 10. Add the eggs and whip with a whisk attachment for 3–5 minutes until foamy and white.",
          "While continuing to beat, gradually add the sugar.",
          "Add 1/2 cup milk and a pinch of salt.",
          "Add 1 cup vanilla extract (not quite full).",
          "Combine the Ingredients:",
          "Add another capful of vanilla and ensure the sugar is dissolved.",
          "Pour the mixture into the ice cream machine with the paddle attachment.",
          "Add 3 1/2 cups cream.",
          "Add enough milk to the machine to bring the mixture to about 2/3 full (approximately 1–1.5 cups).",
          "Set Up the Ice Cream Machine:",
          "Place the canister in the bucket and secure the top.",
          "Pour ice halfway up the sides of the canister.",
          "Sprinkle 1.5 cups of rock salt evenly around the ice.",
          "Plug in the machine and turn it on.",
          "Freeze and Spin:",
          "Let the machine spin for 27 minutes. Do not adjust or interrupt the process.",
          "Final Steps:",
          "Once the 27 minutes are up, unplug the machine.",
          "Transfer the ice cream to a container and freeze overnight for the best texture."
        ]
      },
      {
        "id": "7",
        "name": "Chicken Pot Pie",
        "category": "mains",
        "description": "A hearty chicken pot pie filled with vegetables and creamy sauce, topped with flaky pie crust.",
        "prepTime": "20 mins",
        "cookTime": "50 mins",
        "servings": 6,
        "image": "https://cdn.midjourney.com/876a9a1c-2c6b-48cf-b243-4238062a2bf3/0_3.png",
        "ingredients": [
          "1 cup potato, diced",
          "1 cup onion, diced",
          "1 cup celery, diced",
          "1 cup carrot, diced",
          "1/3 cup melted margarine",
          "1/2 cup all-purpose flour",
          "2 cups chicken broth",
          "1 cup half-and-half",
          "1 teaspoon salt",
          "1/4 teaspoon pepper",
          "4 cups chicken, cooked and chopped",
          "2 pie crusts (store-bought or homemade)"
        ],
        "instructions": [
          "Preheat oven to 400°F.",
          "Saute onion, celery, carrots, and potatoes in melted margarine for 10 minutes.",
          "Add flour to the sauteed mixture, stirring well, and cook for one minute while stirring constantly.",
          "Combine chicken broth and half-and-half in a bowl.",
          "Gradually stir the broth mixture into the vegetable mixture.",
          "Cook over medium heat, stirring constantly, until thickened and bubbly.",
          "Stir in salt and pepper, then add the cooked chicken and mix well.",
          "Pour the mixture into a shallow 2-quart casserole dish and top with pie crusts.",
          "Cut slits in the pie crusts to allow steam to escape.",
          "Bake for 40-50 minutes, or until the pastry is golden brown and the filling is bubbly and cooked through."
        ]
      },
      {
        "id": "8",
        "name": "Best Homemade Alfredo Sauce",
        "category": "sauces",
        "description": "A rich and creamy Alfredo sauce packed with garlic and Parmesan flavor. Perfect for pairing with your favorite pasta.",
        "prepTime": "5 mins",
        "cookTime": "5 mins",
        "servings": "2 cups",
        "image": "/images/alfredo.jpeg",
        "ingredients": [
          "1/2 cup butter",
          "1 1/2 cups heavy whipping cream",
          "2 teaspoons garlic, minced",
          "1/2 teaspoon Italian seasoning",
          "1/2 teaspoon salt",
          "1/4 teaspoon pepper",
          "2 cups freshly grated Parmesan cheese"
        ],
        "instructions": [
          "Add the butter and cream to a large skillet.",
          "Simmer over low heat for 2 minutes.",
          "Whisk in the garlic, Italian seasoning, salt, and pepper, and cook for 1 minute.",
          "Whisk in the Parmesan cheese until melted and smooth.",
          "Serve immediately with pasta or your favorite dish."
        ]
      },
      {
        "id": "9",
        "name": "Ruskie Pierogi (Pierogi with Cheese and Potato Filling)",
        "category": "mains",
        "description": "Traditional Polish pierogi filled with a savory cheese and potato mixture, served boiled or fried.",
        "prepTime": "3 hours 20 mins (including chilling time)",
        "cookTime": "20 mins",
        "servings": 4,
        "image": "/images/pierogi.jpg",
        "ingredients": {
          "filling": [
            "2 potatoes, cooked and mashed (1/2 cup instant or leftover mashed potatoes can be used)",
            "1 cup cottage cheese, drained",
            "1 onion, minced and sautéed in butter until clear",
            "1 egg yolk, beaten",
            "1 tablespoon butter, melted",
            "1 teaspoon sugar",
            "1/4 teaspoon salt",
            "Pepper, to taste"
          ],
          "dough": [
            "2 1/4 cups flour",
            "1/2 teaspoon salt",
            "2 tablespoons butter, cut into pieces",
            "1 large egg, at room temperature",
            "1 egg yolk, at room temperature",
            "1/2 cup reduced-fat milk, at room temperature",
            "2 tablespoons sour cream, at room temperature"
          ],
          "toPrepare": [
            "12 cups salted water"
          ]
        },
        "instructions": [
          "Combine all ingredients listed under filling and refrigerate until ready to assemble pierogi.",
          "In a food processor, combine flour, salt, and butter.",
          "In a separate bowl, blend together the egg, egg yolk, milk, and sour cream.",
          "Add the egg mixture to the flour mixture and process until the dough cleans the sides of the bowl and sticks together (the dough will be slightly sticky).",
          "Remove the dough from the processor, shape it into a ball, wrap in plastic, and chill for 3 hours or overnight.",
          "Cut the dough into thirds and roll each section out on a floured surface into a 12-inch round.",
          "Cut each round into 8 (3-inch) circles (using a glass works well).",
          "Place about 2 teaspoons of filling on each dough circle.",
          "Moisten the outer edges with water and fold the dough over to close.",
          "Seal the edges by pressing gently with the back of a fork or pinching together with your fingers.",
          "In a large pot, bring salted water to a boil.",
          "Cook 12 pierogi at a time, reducing the heat to a gentle boil. Boil until the pierogi float to the surface (about 5 minutes).",
          "Remove with a slotted spoon, drain on a paper towel, and transfer to a serving dish.",
          "Repeat with the remaining pierogi.",
          "Serve warm, freeze for later use, or fry in butter over medium heat, lightly browning both sides before serving."
        ]
      },
      {
        "id": "10",
        "name": "Crepes",
        "category": "breakfast",
        "description": "Light and versatile crepes perfect for sweet or savory fillings.",
        "prepTime": "1 hour 10 mins (including chilling time)",
        "cookTime": "20 mins",
        "servings": 8,
        "image": "https://cdn.midjourney.com/806aae9b-79db-4541-9afd-449bbc7ddd88/0_2.png",
        "ingredients": [
          "2 eggs",
          "1 cup milk",
          "2/3 cup all-purpose flour",
          "1 pinch salt",
          "1 1/2 teaspoons vegetable oil"
        ],
        "instructions": [
          "In a blender, combine eggs, milk, flour, salt, and oil. Process until smooth. Cover and refrigerate for 1 hour.",
          "Heat a skillet over medium-high heat and lightly brush with oil.",
          "Pour 1/4 cup of crepe batter into the pan, tilting to completely coat the surface.",
          "Cook for 2 to 5 minutes, turning once, until golden.",
          "Repeat with the remaining batter. Serve with your choice of sweet or savory fillings."
        ]
      },
      {
        "id": "11",
        "name": "Maddox Buttermilk Rolls",
        "category": "sides",
        "description": "Soft and fluffy buttermilk rolls, perfect for any meal.",
        "prepTime": "2 hours (including rising time)",
        "cookTime": "15 mins",
        "servings": 24,
        "image": "https://cdn.midjourney.com/695e974f-b461-4d67-8133-3993f56fe674/0_1.png",
        "ingredients": [
          "1 1/2 cups buttermilk",
          "1/2 teaspoon baking soda",
          "1/4 cup butter",
          "1 tablespoon yeast",
          "1/8 cup water",
          "1/3 cup sugar",
          "2 eggs",
          "1 teaspoon salt",
          "4 to 4 1/2 cups flour"
        ],
        "instructions": [
          "Heat the buttermilk until warm. Stir in the baking soda and butter until combined.",
          "In a small bowl, soften the yeast in the water.",
          "In a large bowl, combine all the ingredients, including the yeast mixture and buttermilk mixture. Mix until a dough forms.",
          "Let the dough rise in a warm place until doubled in size, about 1 hour.",
          "Roll or shape the dough into the desired shape for rolls.",
          "Place the rolls on a baking sheet and let them rise again until doubled in size, about 30 minutes.",
          "Preheat the oven to 375°F.",
          "Bake the rolls for 12 to 15 minutes, or until golden brown."
        ]
      },
      {
        "id": "12",
        "name": "German Pancakes",
        "category": "mains",
        "description": "Fluffy and dramatic German pancakes, perfect for a hearty breakfast or brunch.",
        "prepTime": "10 mins",
        "cookTime": "18 mins",
        "servings": 6,
        "image": "/images/german_pancakes.jpg",
        "ingredients": [
          "6 eggs",
          "1 cup milk",
          "1 cup flour",
          "1/4 teaspoon salt",
          "6 tablespoons butter or margarine"
        ],
        "instructions": [
          "Preheat the oven to 450°F (232°C).",
          "In a blender or mixing bowl, blend together the eggs, milk, flour, and salt until smooth.",
          "Place the butter in a 9x13-inch baking pan and melt it in the preheated oven.",
          "Carefully remove the pan from the oven once the butter is melted.",
          "Pour the batter into the hot, buttered pan.",
          "Return the pan to the oven and bake for 18 minutes. Do not peek during baking.",
          "The pancake will puff up dramatically and become golden.",
          "Remove from the oven, cut into 6 large squares, and serve immediately."
        ]
      },
      {
        "id": "13",
        "name": "Chicken Pancit Bihon",
        "category": "mains",
        "description": "A flavorful Filipino noodle dish with chicken, vegetables, and rice noodles, perfect for any occasion.",
        "prepTime": "30 mins",
        "cookTime": "30 mins",
        "servings": 6,
        "image": "https://cdn.midjourney.com/23611250-6f3a-400f-ac08-3995eaa3acbc/0_2.png",
        "ingredients": [
          "1 small-to-medium rotisserie chicken",
          "1 8-ounce package of rice noodles (bihon)",
          "1 large onion, diced",
          "5 cloves of garlic, minced",
          "1/2 head of cabbage, sliced into medium-sized strips",
          "2 cups carrots, sliced (more okay, if desired)",
          "2 tablespoons cooking oil (peanut oil preferred)",
          "2 cups celery, sliced (more okay, if desired)",
          "2 cups sugar peas (leave whole; more okay, if desired)",
          "1/4 cup dark soy sauce (tip: if soy sauce is not dark, add 1/2 tablespoon of Kitchen Bouquet)",
          "1 teaspoon lemon pepper",
          "1/2 cup green onion (optional garnish)",
          "Lemon slices (optional, to sprinkle before serving)"
        ],
        "instructions": [
          "Debone the rotisserie chicken ahead of time. Make chicken broth by boiling the rotisserie chicken skin and bones in 5 cups of water. Set aside.",
          "Soak the rice noodles in a bowl of warm water.",
          "In a large wok or pan, heat the cooking oil over medium heat and sauté the onions and garlic for 2 minutes.",
          "Add the carrots and stir fry for 5 minutes.",
          "Add the celery and stir fry for 2 minutes.",
          "Add the cabbage and chicken and continue stir frying for 5 minutes, until all the vegetables are tender.",
          "Add 3 cups of homemade chicken broth, sugar peas, soy sauce, and lemon pepper to the pan. Boil for 2 minutes.",
          "Drain the soaked noodles and add them to the chicken and vegetable mixture. Slightly reduce the heat.",
          "Continue stir frying until the noodles absorb the broth and the dish is dry in consistency. If needed, additional broth can be added until the noodles are tender and fully cooked.",
          "Adjust salt and pepper to taste.",
          "Serve with green onions and/or lemon juice from the lemon slices."
        ]
      },
      {
        "id": "14",
        "name": "Carrot Cake with Creamy Frosting",
        "category": "desserts",
        "description": "A moist and flavorful carrot cake topped with creamy frosting and a sprinkle of nuts, perfect for any occasion.",
        "prepTime": "30 mins",
        "cookTime": "40 mins",
        "servings": 12,
        "image": "https://cdn.midjourney.com/b2fad301-10fa-43c2-91e6-771269e1fb48/0_0.png",
        "ingredients": [
          "2 cups (260g) all-purpose flour, spooned and leveled",
          "2 teaspoons baking soda",
          "1/2 teaspoon fine sea salt",
          "1 1/2 teaspoons ground cinnamon",
          "1 1/4 cups (295ml) vegetable oil",
          "1 cup (200g) granulated sugar",
          "1 cup (190g) lightly packed brown sugar",
          "1 teaspoon vanilla extract",
          "4 large eggs, at room temperature",
          "3 cups (300g) grated peeled carrots (5 to 6 medium carrots)",
          "1 cup (120g) coarsely chopped pecans",
          "1/2 cup (70g) raisins",
          "8 ounces (225g) cream cheese, at room temperature",
          "2 teaspoons cornstarch (optional)",
          "1 1/4 cups (140g) powdered sugar",
          "1/3 cup (80ml) cold heavy cream",
          "1/2 cup (50g) coarsely chopped pecans, for topping cake"
        ],
        "instructions": [
          "Position a rack in the middle of the oven. Preheat the oven to 350°F (176°C).",
          "Grease two 9-inch round cake pans, line the bottom with parchment paper, and then grease the top. Or grease and flour the bottom and sides of both pans.",
          "Whisk flour, baking soda, salt, and cinnamon in a medium bowl until very well blended.",
          "In a separate bowl, whisk the oil, granulated sugar, brown sugar, and vanilla.",
          "Add the eggs, one at a time, whisking after each one.",
          "Switch to a large rubber spatula. Scrape the sides and bottom of the bowl, then add the dry ingredients in three parts, gently stirring until they disappear and the batter is smooth.",
          "Stir in the carrots, nuts, and raisins.",
          "Divide the cake batter between the prepared cake pans. Bake until the tops of the cake layers are springy when touched and when a toothpick inserted into the center of the cake comes out clean, 35 to 45 minutes.",
          "Cool the cakes in the pans for 15 minutes, then carefully turn the cake layers out onto cooling racks. Remove the parchment paper and cool completely.",
          "In a large bowl, beat the cream cheese with a handheld mixer on medium speed until smooth and creamy, about 1 minute.",
          "Beat in the powdered sugar and cornstarch. Sift the powdered sugar and cornstarch over the cream cheese to remove lumps.",
          "Pour in the heavy cream. Beat on medium speed for 2 to 3 minutes or until the frosting is whipped and creamy. Chill covered until ready to frost the cake.",
          "When the cake layers are completely cool, frost the top of one cake layer and place the second cake layer on top.",
          "Add the remaining frosting to the top of the carrot cake and use a butter knife or small spatula to swirl the frosting around. Leave the sides of the cake unfrosted.",
          "Finish with a handful of nuts on top."
        ]
      },
      {
        "id": "15",
        "name": "Peanut Butter Bars with Chocolate Frosting",
        "category": "desserts",
        "description": "Soft and chewy peanut butter bars topped with a rich chocolate frosting.",
        "prepTime": "20 mins",
        "cookTime": "15 mins",
        "servings": 24,
        "image": "/images/peanut_butter_bars.jpg",
        "ingredients": [
          "1 cup butter, softened",
          "1 cup sugar",
          "1 cup brown sugar, firmly packed",
          "1 teaspoon vanilla extract",
          "2 large eggs",
          "1 cup (270 g) peanut butter",
          "1 1/2 cups (405 g) peanut butter",
          "2 cups old fashioned oats",
          "2 cups flour",
          "1 teaspoon baking soda",
          "1 teaspoon salt",
          "1/2 cup butter, softened (for frosting)",
          "1/4 cup milk (for frosting)",
          "2 teaspoons vanilla extract (for frosting)",
          "4 tablespoons cocoa (for frosting)",
          "3 cups powdered sugar (for frosting)"
        ],
        "instructions": [
          "Preheat the oven to 350°F.",
          "In a large bowl, cream together the butter, sugar, and brown sugar.",
          "Add vanilla, eggs, and 1 cup (270 g) peanut butter; stir to combine.",
          "Mix in oats, flour, baking soda, and salt until well combined.",
          "Spray a half-sheet jelly roll pan (approximately 17.8 x 12.8 x 1 inch) with nonstick cooking spray and spread the dough evenly.",
          "Bake for 15 minutes and remove from the oven.",
          "Drop the remaining peanut butter by spoonfuls over the warm bars. Spread gently as the peanut butter melts. Allow to cool until the peanut butter sets.",
          "While the bars cool, prepare the frosting:",
          "Mix together the softened butter, milk, vanilla, cocoa, and powdered sugar using a hand mixer until smooth.",
          "Spread the frosting evenly over the bars."
        ]
      },
      {
        "id": "16",
        "name": "Cinnamon Rolls",
        "category": "desserts",
        "description": "Soft and fluffy cinnamon rolls with a sweet cinnamon-sugar filling and a creamy frosting.",
        "prepTime": "2 hours 30 mins (including rising time)",
        "cookTime": "12 mins",
        "servings": 12,
        "image": "/images/cinnamon_rolls.jpg",
        "ingredients": [
          "1 tablespoon yeast (instant yeast preferred)",
          "1/2 cup hot mashed potatoes (instant or reheated leftovers)",
          "1/4 cup vegetable oil",
          "1/4 cup sugar",
          "1 1/2 teaspoons salt",
          "1 1/4 cup scalded milk",
          "1 egg",
          "4 to 4 1/4 cups all-purpose flour",
          "1/4-1/2 cup melted butter (for filling)",
          "2/3 cup white or brown sugar (for filling)",
          "1-2 tablespoons cinnamon (for filling)",
          "1/4 cup butter (for frosting)",
          "1 teaspoon vanilla (for frosting)",
          "2 1/2 cups powdered sugar (for frosting)",
          "2 tablespoons milk (for frosting)",
          "Pinch of salt (for frosting)"
        ],
        "instructions": [
          "In a small bowl, mix the mashed potatoes, oil, sugar, scalded milk, and salt. Allow the mixture to cool to lukewarm.",
          "Transfer the lukewarm mixture to a mixer or large mixing bowl. Add the yeast, egg, and 2 cups of flour. Mix until smooth.",
          "Mix in the remaining 2 cups of flour gradually, adding more if needed until the dough cleans the sides of the bowl and becomes smooth and elastic. Knead for 5 minutes in the mixer or by hand.",
          "Form the dough into a ball and place it in a lightly greased bowl. Turn the dough once to coat, then cover with a clean towel or greased plastic wrap. Let it rise in a warm place until doubled, about 1 hour.",
          "Prepare the cinnamon-sugar filling by mixing sugar and cinnamon in a small bowl.",
          "For the frosting, melt butter in a large microwave-safe bowl or measuring cup. Add the remaining frosting ingredients and mix until smooth. Adjust consistency by adding more milk for thinner frosting or more powdered sugar for thicker frosting.",
          "After the dough has risen, punch it down and roll it into a large rectangle, about 1/4 inch thick.",
          "Spread melted butter over the dough, leaving 1/2 inch uncovered on one long edge. Sprinkle evenly with the cinnamon-sugar mixture.",
          "Roll the dough tightly into a log and pinch the seam to seal. Cut into 1 1/2-inch slices and place them on a greased 11x17-inch cookie sheet. Press each roll down slightly.",
          "Cover the rolls and let them rise until doubled, about 1 hour.",
          "Preheat the oven to 400°F. Bake the rolls for 10-12 minutes, or until golden brown.",
          "Frost the rolls with the prepared frosting and serve warm."
        ]
      },
      {
        "id": "17",
        "name": "Caramel",
        "category": "desserts",
        "description": "Rich and creamy caramel candy made with sugar, butter, and cream.",
        "prepTime": "10 mins",
        "cookTime": "30 mins",
        "servings": "Varies",
        "image": "/images/caramel.jpg",
        "ingredients": [
          "3 cups sugar",
          "1 cup + 2 tablespoons corn syrup",
          "3/4 cup butter",
          "3 cups Half & Half or cream"
        ],
        "instructions": [
          "In a large saucepan, mix sugar, corn syrup, and butter. Heat over medium heat until the sugar dissolves, stirring occasionally.",
          "Slowly add the cream, continuing to stir.",
          "Cook the mixture to the hardball stage (approximately 250°F or 121°C), stirring frequently to avoid burning.",
          "Once the mixture reaches the desired temperature, pour it into a Pyrex dish or other heatproof container.",
          "Allow the caramel to cool completely before cutting into pieces and serving."
        ]
      },
      {
        "id": "18",
        "name": "Golden Grahams S'mores Bars",
        "category": "desserts",
        "description": "A quick and easy no-bake treat with Golden Grahams cereal, marshmallows, and chocolate for a delicious s'mores-inspired dessert.",
        "prepTime": "15 mins",
        "cookTime": "1 hour (cooling time)",
        "servings": 24,
        "image": "https://cdn.midjourney.com/81654d5a-dc7e-4a94-9899-a5410e7b1d3c/0_2.png",
        "ingredients": [
          "8 cups Golden Grahams™ cereal",
          "1 bag (10 oz) miniature marshmallows (5 1/2 cups)",
          "1 1/2 cups milk chocolate chips (9 oz)",
          "5 tablespoons butter or margarine",
          "1/4 cup sugar",
          "1 tablespoon water",
          "1 teaspoon vanilla"
        ],
        "instructions": [
          "Grease a 13x9-inch pan with butter. Measure the cereal into a large bowl.",
          "Reserve 1 cup of the marshmallows. In a 3-quart saucepan, heat the remaining 4 1/2 cups of marshmallows, chocolate chips, butter, sugar, and water over low heat, stirring occasionally, until completely melted. Remove from heat and stir in the vanilla.",
          "Pour the marshmallow mixture over the cereal in the bowl and stir until evenly coated. Stir in the reserved 1 cup of marshmallows.",
          "Press the mixture firmly into the prepared pan. Cool for at least 1 hour until firm.",
          "For bars, cut into 6 rows by 4 rows. Store loosely covered at room temperature."
        ]
      },
      {
        "id": "19",
        "name": "Fudgy Brownies",
        "category": "desserts",
        "description": "Rich, fudgy brownies with a shiny top and gooey center, perfect for chocolate lovers.",
        "prepTime": "10 mins",
        "cookTime": "28 mins",
        "inactiveTime": "2 hours",
        "totalTime": "2 hours 38 mins",
        "servings": "1 Pan (9×9)",
        "image": "https://cdn.midjourney.com/29c1d61c-f8cd-41f8-8028-c5eb1f60e080/0_3.png",
        "ingredients": [
          "1 cup (120g) all-purpose flour",
          "1/2 teaspoon baking powder",
          "1/2 teaspoon salt",
          "1/2 cup (43g) unsweetened cocoa powder",
          "1 teaspoon espresso powder (optional, omit if you don't like coffee)",
          "3/4 cup (170g) unsalted butter",
          "2 tablespoons (28ml) oil (canola, vegetable, or coconut)",
          "1 1/3 cups (265g) granulated sugar, divided",
          "2 large eggs",
          "1 large egg yolk",
          "3/4 cup (128g) chocolate chips"
        ],
        "instructions": [
          "Preheat the oven to 350°F (175°C). Line a 9×9-inch baking pan with parchment paper and lightly spray with non-stick baking spray. Set aside.",
          "In a large bowl, sift together the flour, baking powder, salt, cocoa powder, and espresso powder. Set aside.",
          "In a medium saucepan, combine the butter, oil, and 1/3 cup of the sugar. Heat over medium heat, stirring frequently, until the butter is completely melted. Remove from heat.",
          "In a large mixing bowl, whisk together the eggs and the remaining sugar until well combined, about 30 seconds.",
          "Slowly pour the warm butter mixture into the egg mixture, adding it gradually and whisking constantly until completely combined.",
          "Add the dry ingredients and chocolate chips to the wet mixture. Using a rubber spatula, gently stir until just combined. *Do not over mix. Stop stirring when you see the last trace of dry ingredients.",
          "Scrape the batter into the prepared pan and smooth the top.",
          "Bake for 30 minutes, or until the edges are firm and the top is shiny and slightly cracked.",
          "Place the pan on a cooling rack and cool completely before slicing."
        ]
      },
      {
        "id": "20",
        "name": "Chocolate Peanut Butter Candy",
        "category": "desserts",
        "description": "Rich and creamy peanut butter candy layered with smooth chocolate, perfect for satisfying sweet cravings.",
        "prepTime": "20 mins",
        "cookTime": "10 mins",
        "servings": "Varies",
        "image": "/images/peanut_butter_candy.jpg",
        "ingredients": [
          "1 cup butter, room temperature",
          "2 cups peanut butter",
          "1 bag (2 lbs) powdered sugar",
          "1 1/2 lbs chocolate (melted in two portions, ~3/4 lb each)"
        ],
        "instructions": [
          "In a large bowl, mix the butter and peanut butter together until smooth.",
          "Gradually add the powdered sugar until the mixture is dry and no longer sticky.",
          "Line a cookie sheet with wax paper, leaving excess paper hanging over the edges.",
          "Spread the peanut butter mixture evenly onto the pan. Cover with wax paper and use a rolling pin to roll it smooth. Remove the top wax paper.",
          "Pour half of the melted chocolate over the peanut butter mixture and spread it evenly. Allow it to cool.",
          "Cover with wax paper again. Place another cookie sheet (bottom side down) on top of the candy and flip the candy out onto the upside-down pan.",
          "Slide the candy carefully back into the original pan, gently pressing the edges down into the pan.",
          "Pour the remaining melted chocolate over the candy, spreading it evenly.",
          "Cool until the chocolate is no longer shiny but not fully hardened.",
          "Cut the candy into pieces before the chocolate gets too hard to prevent cracking.",
          "Allow the candy to cool completely to harden the chocolate."
        ]
      },
      {
        "id": "21",
        "name": "Sweet Chex Mix",
        "category": "snacks",
        "description": "A sweet and crunchy Chex mix with coconut and a caramel-like coating, perfect for snacking.",
        "prepTime": "5 mins",
        "cookTime": "10 mins",
        "servings": "Varies",
        "image": "/images/chex-candy.jpg",
        "ingredients": [
          "8 cups Chex cereal (maybe 9 if too syrupy)",
          "1/2-1 cup coconut",
          "1 cup sugar",
          "1 cup Karo syrup",
          "1 cube butter"
        ],
        "instructions": [
          "In a saucepan, combine the sugar, Karo syrup, and butter.",
          "Boil the mixture for 2 minutes, stirring frequently.",
          "In a large bowl, combine the Chex cereal and coconut.",
          "Pour the hot syrup mixture over the Chex and coconut, stirring until evenly coated.",
          "Optionally, add nuts for additional flavor and texture.",
          "Let the mix cool slightly before serving."
        ]
      },
      {
        "id": "22",
        "name": "White Bread with Poolish",
        "category": "breads",
        "description": "A homemade artisan bread with a crusty exterior and soft interior, made using a long fermentation process.",
        "prepTime": "14 hours (including fermentation and rising)",
        "cookTime": "40 mins",
        "servings": "2 loaves",
        "image": "/images/bread.jpg",
        "ingredients": [
          "500g white flour",
          "500g water at 80°F",
          "Scant 1/8 teaspoon instant dried yeast",
          "500g white flour (second addition)",
          "250g water at 105°F",
          "25g salt (or 21g as per original recipe)",
          "3g instant dried yeast"
        ],
        "instructions": [
          "At about 10 PM, mix 500g white flour, 500g water at 80°F, and a scant 1/8 teaspoon instant dried yeast. Cover and let sit overnight.",
          "The next day at about 11 AM, mix 500g white flour, 250g water at 105°F, 25g salt (or 21g if preferred), and 3g instant dried yeast in a bowl.",
          "Combine the mixture made the night before with the dough prepared in the morning to form a single dough.",
          "Let the dough rise for about 3 hours, folding it once after about an hour.",
          "Form the dough into loaves. Place the loaves in proofing baskets lined with parchment paper.",
          "Preheat a Dutch oven in the oven at 475°F while forming the loaves.",
          "After about an hour, carefully transfer the loaves into the preheated Dutch oven. Keep the parchment paper under the loaves.",
          "Bake with the lid on for about 20 minutes.",
          "Remove the lid and insert a thermometer. Continue baking until the internal temperature reaches 185°F in the center.",
          "Let the bread cool for at least 20 minutes before slicing."
        ]
      },
      {
        "id": "23",
        "name": "Funeral Potatoes",
        "category": "sides",
        "description": "A comforting and cheesy potato casserole topped with buttery corn flakes, perfect for gatherings.",
        "prepTime": "20 mins",
        "cookTime": "1 hour",
        "servings": 8,
        "image": "/images/funeral-potatoes.jpg",
        "ingredients": [
          "5-6 potatoes, boiled and cut into small squares",
          "1 cube butter, melted",
          "1-2 cans cream of chicken soup",
          "1 cup sour cream",
          "1 tablespoon salt and spice (to taste)",
          "3 cups grated cheese",
          "Optional: 1/4 cup green onions, finely chopped",
          "2 cups crushed corn flakes",
          "1 tablespoon butter (for topping)"
        ],
        "instructions": [
          "Preheat the oven to 325°F.",
          "Boil the potatoes until tender, then cut them into small squares.",
          "In a large bowl, mix the potatoes with the melted butter.",
          "In a separate bowl, combine the cream of chicken soup, sour cream, salt, spice, grated cheese, and optional green onions.",
          "Mix the soup and cheese mixture with the potatoes until well combined.",
          "Transfer the potato mixture into a greased casserole dish.",
          "In a small bowl, mix the crushed corn flakes with 1 tablespoon melted butter.",
          "Spread the buttered corn flakes evenly over the top of the casserole.",
          "Bake for 1 hour, or until the casserole is bubbly and the topping is golden brown."
        ]
      },
      {
        "id": "24",
        "name": "Penuche",
        "category": "desserts",
        "description": "A rich and creamy caramel fudge made with brown sugar, milk, and butter, perfect for wrapping in waxed paper.",
        "prepTime": "5 mins",
        "cookTime": "10 mins",
        "servings": "Varies",
        "image": "https://meaningfuleats.com/wp-content/uploads/2024/11/penuche-fudge.jpg",
        "ingredients": [
          "2 cups sugar",
          "1 cup brown sugar",
          "1 cup rich milk",
          "1/2 tablespoon light corn syrup",
          "2 tablespoons butter",
          "1 teaspoon vanilla"
        ],
        "instructions": [
          "In a medium saucepan, combine the sugar, brown sugar, milk, corn syrup, and butter.",
          "Bring the mixture to a boil and cook until it reaches 228°F (109°C) on a candy thermometer.",
          "Pour the hot mixture onto a marble surface or heat-resistant surface and allow it to cool slightly.",
          "Once cooled, add 1 teaspoon vanilla to the mixture.",
          "Stir the mixture with a wooden paddle until it thickens and begins to set.",
          "Roll the penuche into small pieces and wrap each piece in waxed paper."
        ]
      },
      {
        "id": "25",
        "name": "Pete's Scratch Pancakes",
        "category": "breakfast",
        "description": "Tall, light, and fluffy pancakes made from simple pantry ingredients—perfect for a hearty morning meal.",
        "prepTime": "10 mins",
        "cookTime": "20 mins",
        "servings": 4,
        "image": "",
        "ingredients": [
          "2 cups flour",
          "3 tablespoons sugar",
          "1/2 teaspoon salt",
          "1 tablespoon baking powder",
          "2 eggs, beaten separately",
          "1/4 cup butter, melted (1/8 pound)",
          "1 3/4 cups milk"
        ],
        "instructions": [
          "In a large bowl, mix the flour, sugar, salt, and baking powder.",
          "In a separate bowl, combine the milk, melted butter, and beaten eggs.",
          "Slowly stir the wet mixture into the dry ingredients until just combined; do not overmix.",
          "Let the batter sit for at least 10 minutes while heating the griddle to 325°F or a pan to medium-high heat.",
          "Pour batter onto the hot griddle or pan and cook until bubbles form and edges are dry. Flip and cook until golden brown.",
          "Serve hot with butter and syrup."
        ]
      },
      {
        "id": "26",
        "name": "Ultimate Chocolate Chip Cookies",
        "category": "desserts",
        "description": "Loaded with chocolate chips and nuts, these cookies are crispy on the outside and soft on the inside.",
        "prepTime": "15 mins",
        "cookTime": "8 mins",
        "servings": 60,
        "image": "/images/chocolate_chip_cookies.png",
        "ingredients": [
          "1 lb butter, softened",
          "2 cups brown sugar",
          "1 1/2 cups sugar",
          "2 tablespoons vanilla",
          "3 eggs",
          "5 1/2 cups flour",
          "1 1/2 teaspoons salt",
          "1 1/2 teaspoons baking soda",
          "6 cups chocolate chips",
          "4 cups nuts"
        ],
        "instructions": [
          "Preheat oven to 350°F and line baking sheets with parchment paper.",
          "Cream the softened butter with brown sugar until light and fluffy.",
          "Add sugar, vanilla, and eggs, mixing well after each addition.",
          "In a separate bowl, whisk together flour, salt, and baking soda.",
          "Gradually add the dry ingredients to the butter mixture and mix until just combined.",
          "Fold in the chocolate chips and nuts until evenly distributed.",
          "Drop dough by rounded spoonfuls onto the prepared parchment-lined baking sheets.",
          "Bake for 8 minutes, or until edges are lightly golden but centers still look slightly underbaked.",
          "Allow cookies to cool on the baking sheet for 5 minutes before transferring to a wire rack."
        ]
      },
      {
        "id": "27",
        "name": "Chicken Tikka Masala",
        "category": "mains",
        "description": "Tender, spiced chicken in a creamy tomato-based curry sauce. Restaurant-quality flavor made easy at home, perfect served over rice.",
        "prepTime": "15 mins (plus 30 mins marinating)",
        "cookTime": "40 mins",
        "servings": 4,
        "image": "https://cdn.midjourney.com/a4e8c8e7-9f6a-4b2c-8d5e-3e7f2c1a9b8d/0_0.png",
        "ingredients": {
          "for_the_chicken": [
            "1.5 lbs boneless, skinless chicken breasts or thighs, cubed",
            "1 cup plain yogurt",
            "3 tablespoons ginger-garlic paste",
            "2 tablespoons garam masala",
            "1 tablespoon ground cumin",
            "1 tablespoon ground coriander",
            "1 teaspoon turmeric",
            "1 teaspoon chili powder (adjust to taste)",
            "1 tablespoon lemon juice",
            "Salt to taste"
          ],
          "for_the_sauce": [
            "3 tablespoons butter or oil",
            "1 large onion, diced",
            "4 cloves garlic, minced",
            "1 tablespoon ginger, minced",
            "1 (28 oz) can crushed tomatoes",
            "1 cup heavy cream (or coconut milk for dairy-free)",
            "2 tablespoons tomato paste",
            "1 tablespoon sugar (to balance acidity)",
            "1 teaspoon garam masala",
            "1 teaspoon cumin",
            "Salt and pepper to taste",
            "Fresh cilantro for garnish",
            "Basmati rice for serving"
          ]
        },
        "instructions": [
          "Marinate the chicken: In a bowl, combine yogurt, ginger-garlic paste, garam masala, cumin, coriander, turmeric, chili powder, lemon juice, and salt. Add the chicken cubes and mix well to coat. Let marinate for at least 30 minutes (or up to 4 hours for deeper flavor).",
          "Heat butter or oil in a large skillet over medium-high heat. Working in batches if needed, cook the marinated chicken until golden brown on all sides, about 8-10 minutes. Remove and set aside.",
          "In the same skillet, add the diced onion and cook until softened and golden, about 5 minutes.",
          "Add minced garlic and ginger, cooking for 1 minute until fragrant.",
          "Stir in the tomato paste and cook for 2 minutes, stirring constantly.",
          "Pour in the crushed tomatoes and bring to a simmer. Cook for 5 minutes.",
          "Return the cooked chicken to the skillet along with any accumulated juices.",
          "Reduce heat to medium-low and stir in the heavy cream, garam masala, cumin, sugar, salt, and pepper.",
          "Simmer gently for 15-20 minutes, stirring occasionally, until the sauce thickens and chicken is cooked through. Do not boil vigorously.",
          "Taste and adjust seasonings as needed. Add more cream if sauce is too thick, or simmer longer if too thin.",
          "Garnish with fresh cilantro and serve over basmati rice with naan bread on the side."
        ]
      },

    {
        "id": "27",
        "name": "Caramels",
        "category": "desserts",
        "description": "Homemade creamy caramels cooked to hard ball stage.",
        "prepTime": "10 mins",
        "cookTime": "30 mins",
        "servings": "24 pieces",
        "image": "https://cdn.midjourney.com/caramels/caramels.png",
        "ingredients": [
          "4 cups sugar",
          "1 cup corn syrup",
          "1 cup butter",
          "4 cups cream"
        ],
        "instructions": [
          "Mix sugar, corn syrup, butter, and 2 cups of cream in a large pot.",
          "Heat to boiling.",
          "Slowly add the remaining 2 cups of cream. Don't add too much at a time.",
          "Don't let it stop boiling while adding cream.",
          "After all cream is added, don't stir much. Just stir the bottom occasionally to keep it from burning.",
          "Cook to hard ball stage (300-310°F). Let cool and cut into pieces."
        ]
    }

];